import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import App from './App';
import PaginaFamilia from './components/familia/PaginaFamilia';
import PaginaPedido from './components/familia/pagina-pedido';
import PaginaEntrar from './components/familia/pagina-entrar';
import './index.css';

// ============================================
// Interceptadores globais de autenticação (Cookies HttpOnly)
// O token NÃO fica mais no JavaScript/localStorage.
// ============================================

const USER_KEY = 'tresco_user';

function handleUnauthorized() {
  localStorage.removeItem(USER_KEY);
  window.location.reload();
}

// 1) Interceptor global para AXIOS — envia cookies automaticamente
axios.defaults.withCredentials = true;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Não redirecionar para rotas de auth (login, refresh, logout)
    // /api/familia (0067): 401 é "link inválido" da página pública, não sessão
    // do painel expirada — recarregar prenderia a família num laço.
    if (
      error.response?.status === 401 &&
      !error.config?.url?.includes('/auth/') &&
      !error.config?.url?.includes('/api/familia')
    ) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

// 2) Interceptor global para FETCH — envia cookies automaticamente, SÓ para o
// próprio painel. Forçar `credentials: 'include'` em outro domínio quebra o
// CORS de quem responde `Access-Control-Allow-Origin: *` (o navegador recusa
// com PreflightWildcardOriginNotAllowed e o fetch vira "Failed to fetch"): era
// o que derrubava o envio de vídeo ao Supabase Storage e a busca no ViaCEP.
// E um 401 de outro domínio não é sessão do painel expirada.
const originalFetch = window.fetch.bind(window);
window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url;
  const mesmaOrigem = new URL(url, window.location.href).origin === window.location.origin;
  if (mesmaOrigem) init = { ...init, credentials: 'include' };

  return originalFetch(input, init).then((response) => {
    if (response.status === 401 && mesmaOrigem) {
      if (!url.includes('/auth/') && !url.includes('/api/familia')) {
        handleUnauthorized();
      }
    }
    return response;
  });
};

// ============================================

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
// A página da família (spec 0067) é pública: abre pelo link do WhatsApp, sem
// login. Desviada aqui, antes do App, para não disparar a verificação de sessão.
const caminho = window.location.pathname;
const tokenDaFamilia = /^\/familia\/([A-Za-z0-9_-]{20,})\/?$/.exec(caminho)?.[1];
// 0071: o link de uso único do pedido na hora e a entrada pelo telefone, também públicos.
const tokenDoPedido = /^\/familia\/p\/([A-Za-z0-9_-]{20,})\/?$/.exec(caminho)?.[1];
const entrarPeloTelefone = /^\/familia\/entrar\/?$/.test(caminho);

root.render(
  <React.StrictMode>
    {tokenDaFamilia ? <PaginaFamilia token={tokenDaFamilia} />
      : tokenDoPedido ? <PaginaPedido token={tokenDoPedido} />
        : entrarPeloTelefone ? <PaginaEntrar /> : <App />}
  </React.StrictMode>
);